module.exports = __webpack_public_path__ + "img/user-icon.b1c131b8.jpg";